import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getCurrentUser } from '~/services/user.service';
import { fromJSON } from '~/types/User';

import { CURRENT_USER_QUERY_KEY } from '../constants/auth.const';

export const useCurrentUser = () => {
  const {
    data: user,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryFn: getCurrentUser,
    queryKey: CURRENT_USER_QUERY_KEY,
    retry: false,
    select: (response) => fromJSON(response.data),
  });

  const refreshUser = useCallback(async () => {
    const { data } = await refetch();
    return data;
  }, [refetch]);

  return { error, isLoading, refreshUser, user };
};
